import BasicLayout from "../../layouts/BasicLayout.vue";
let moduleName = "CompanyManager";
const RouteModules = [
  {
    path: "/cases",
    redirect: "/cases/list",
    name: "CasesManager",
    component: BasicLayout,
    showChildren: true,
    groupTitle: "案例管理",
    iconSvg: "log",
    iconFont: "",
    onlyExtentdLayout: true,
    children: [
      {
        path: "/cases/list",
        name: "CasesList",
        component: () => import("@/views/cases/CasesList.vue"),
        meta: {
          module: moduleName,
          isMenu: true,
          showChildren: false,
          title: "案例列表",
          keepAlive: true,
          iconSvg: "log",
          iconFont: "",
          roles: ["ENGINEERING_CASE_ADMIN"],
        },
      },
      {
        path: "/cases/edit/:id?",
        name: "CasesForm",
        component: () => import("@/views/cases/CasesForm.vue"),
        meta: {
          module: moduleName,
          isMenu: false,
          showChildren: false,
          title: "案例编辑",
          keepAlive: true,
          iconSvg: "log",
          iconFont: "",
          roles: ["ENGINEERING_CASE_ADMIN"],
        },
      },
      {
        path: "/cases/type/list",
        name: "CasesTypeList",
        component: () => import("@/views/caseTypes/CaseTypeList.vue"),
        meta: {
          module: moduleName,
          isMenu: true,
          showChildren: false,
          title: "案例类型",
          keepAlive: true,
          iconSvg: "systemSetting",
          iconFont: "",
          roles: ["ENGINEERING_CASE_ADMIN"],
        },
      },
    ],
  },
];

export default RouteModules;
